import React from 'react';
import { Box, xcss } from '@atlaskit/primitives';

export const UnorderedList = ({ children }: { children: React.ReactNode }) => (
	<Box as="ul" xcss={unorderedListBoxStyles}>
		{children}
	</Box>
);

export const UnorderedListItem = ({ children }: { children: React.ReactNode }) => (
	<Box as="li" xcss={listItemBoxStyles}>
		{children}
	</Box>
);

const unorderedListBoxStyles = xcss({
	paddingLeft: 'space.100',
	listStyle: 'none',
});

const listItemBoxStyles = xcss({
	':before': {
		content: '"•"',
		fontSize: '10pt',
		paddingRight: 'space.100',
	},
});
